import { PageLayout } from "@/components/page-layout/PageLayout";
import { FppSearchFilter } from "@/features/search-filter/components/FppSearchFilter";
import {
  SearchFilterSelectorContext,
  SearchFilterSelectorContextType,
} from "@/features/search-filter/context/searchFilterSelectorContext";
import { createFppSearchFilterActions } from "@/features/search-filter/redux/reducer";
import { Box, Row, SeparatorLine } from "@stenajs-webui/core";
import { Card, CardBody, CardHeader } from "@stenajs-webui/elements";
import { SearchFilterContext } from "@stenajs-webui/filter";
import * as React from "react";
import { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { useCurrencySelection } from "@/redux/profile/hooks/UseCurrencySelection";
import { useStatisticsYearSelect } from "../hooks/UseStatisticsYearSelector";
import { useAdvancedStatisticsDataListQuery } from "../hooks/useAdvancedStatisticsDataListQuery";
import { advancedStatisticsListDataFilterVariablesTransformer } from "../lib/transformers/AdvancedStatisticsListDataFilterVariablesTransformer";
import { StatisticsByAdvancedTable } from "./StatisticsByAdvancedTable";
import { statisticsByAdvancedFilterSettings } from "../config/StatisticsByAdvancedFIlterConfig";

interface Props {}

export const StatisticsByAdvancedListCard: React.FC<Props> = () => {
  const dispatch = useDispatch();

  const { year } = useStatisticsYearSelect();
  const { currency } = useCurrencySelection();

  const { committedState, workspaceState } = useContext(
    SearchFilterSelectorContext
  ) as SearchFilterSelectorContextType;

  const {
    advancedStatisticsData,
    called,
    error,
    loading,
    loadAdvancedStatisticsData,
  } = useAdvancedStatisticsDataListQuery();

  const onSearch = () => {
    loadAdvancedStatisticsData({
      variables: {
        byFilterFilterOptions:
          advancedStatisticsListDataFilterVariablesTransformer(
            { ...workspaceState.formModel },
            year,
            currency
          ),
      },
    });
  };

  useEffect(() => {
    if (called) {
      onSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year, currency]);

  return (
    <PageLayout>
      <Helmet title="Advanced - Statistics - FPP" />
      <SearchFilterContext
        state={workspaceState}
        actions={createFppSearchFilterActions(
          "statistics.statisticsByAdvanced"
        )}
        dispatch={dispatch}
      >
        <Card minWidth={"1680px"}>
          <CardHeader
            text={
              loading
                ? "Loading..."
                : `${advancedStatisticsData?.length ?? 0} Results`
            }
          />
          <CardBody>
            <Row>
              <Box>
                <FppSearchFilter
                  onSearch={onSearch}
                  settings={statisticsByAdvancedFilterSettings}
                />
              </Box>
            </Row>
          </CardBody>
          <SeparatorLine />
          <StatisticsByAdvancedTable
            advancedStatisticsData={advancedStatisticsData}
            currentCurrency={currency}
            error={error}
            loading={loading}
          />
        </Card>
      </SearchFilterContext>
    </PageLayout>
  );
};
